<div class="maintenance">
  <img src="assets/images/maintenance.png" alt="" />
  <h4>{{ "maintenance.backSoon" | transloco }}</h4>
  <h2>{{ "maintenance.technicalDifficulties" | transloco }}</h2>
  <p>
    {{ "maintenance.description" | transloco }}
  </p>

  <app-button
    (click)="goBack()"
    [text]="'maintenance.tryAgain' | transloco"
    class="margin-container"
  >
  </app-button>
</div>
